import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../pages/admin/services/admin.service';
import { UserGroupModalComponent } from '../../../shared/user-group-modal/user-group-modal.component';
import { GetUserGroups_Result } from '../../../../type-definitions/admin/responses/admin';

@Component({
  selector: 'app-enable-checklist-workflow-modal',
  templateUrl: './enable-checklist-workflow-modal.component.html',
  styleUrls: ['./enable-checklist-workflow-modal.component.css'],
})
export class EnableChecklistWorkflowModalComponent implements OnInit {
  @Input() mode: any;
  @Input() templateInfo: any;
  userGroups: GetUserGroups_Result[] = [];
  itemChanged = false;
  currentUserGroupID: number;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private adminService: AdminService
  ) {}

  ngOnInit(): void {
    this.getUserGroup();
    if (this.templateInfo.WorkflowInclUserGroupID == null) {
      this.templateInfo.WorkflowInclUserGroupID = -2;
    }
    this.currentUserGroupID = this.templateInfo.WorkflowInclUserGroupID;
  }

  public get ChecklistModeName(): string {
    return this.mode == 'H' ? 'Action Item' : this.mode == 'S' ? 'SM Form' : 'Checklist';
  }

  workflowEnabled() {
    this.itemChanged = true;
    this.templateInfo.WorkflowInclPM = false;
    this.templateInfo.WorkflowInclJobRev = false;
    this.templateInfo.WorkflowInclInvRev = false;
    this.templateInfo.WorkflowInclTimecardManager = false;
    this.templateInfo.WorkflowInclUserGroupID = -2;
    this.currentUserGroupID = -2;
    this.templateInfo.WorkflowUsersCanFinalize = false;
  }

  updateItem() {
    this.itemChanged = true;
  }

  userGroupChange() {
    if (this.templateInfo.WorkflowInclUserGroupID == -1) {
      this.editUserGroup();
    } else {
      this.currentUserGroupID = this.templateInfo.WorkflowInclUserGroupID;
      this.updateItem();
    }
  }

  saveClicked() {
    if (this.itemChanged) {
      this.activeModal.close(this.templateInfo);
    } else {
      this.activeModal.dismiss();
    }
  }

  editUserGroup() {
    const modalRef = this.modalService.open(UserGroupModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.data = null;
    modalRef.result
      .then((result: any) => {
        if (result != null && result.success) {
          this.templateInfo.WorkflowInclUserGroupID = result.UserGroupID;
          this.currentUserGroupID = result.UserGroupID;
          this.getUserGroup();
          this.updateItem();
        } else {
          this.templateInfo.WorkflowInclUserGroupID = this.currentUserGroupID;
        }
      })
      .catch(res => {});
  }

  getUserGroup() {
    this.adminService.getUserGroup().then(response => {
      if (response != null) {
        this.userGroups = response;
      }
    });
  }
}
